import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {

  constructor(
    public router : Router,
    public auth:AuthService
    ) { }

    ngOnInit(): void {

    }

    goHome(){
      this.router.navigateByUrl("");
    }

    logout(){
      this.auth.SignOut();
    }
}
